import React from 'react';
import { ClarovideoLogo } from 'components/ClarovideoLogo';

export const ProfilesHeader = () => {
  return (
    <div className="profile-manager__header">
      <ClarovideoLogo
        width={172}
        height={35}
        classNames="profile-manager-logo"
      />
    </div>
  );
};
